import {
  ERROR_TECNICO,
  TURNO_ASIGNADO,
  SUC_SIN_CUPO,
  OTORGADO
} from "./step-constants";

export const step1 = {
  OTORGADO,
  TURNO_ASIGNADO,
  SUC_SIN_CUPO,
  ERROR_TECNICO,
  ERROR: ERROR_TECNICO
};
